import React, { FC } from 'react'
import { Typography } from 'antd'
import { formatCurrency } from '@/utils/priceCalculations'
import { PricingData } from '@/utils/priceCalculations'

const { Text } = Typography

interface OrderTotalDisplayProps {
  largeIceCubeAmount: number
  smallIceCubeAmount: number
  crushedIceAmount: number
  coarselyCrushedIceAmount: number
  pricingData: PricingData
  customerId?: string
  className?: string
}

export const OrderTotalDisplay: FC<OrderTotalDisplayProps> = ({
  largeIceCubeAmount,
  smallIceCubeAmount,
  crushedIceAmount,
  coarselyCrushedIceAmount,
  pricingData,
  customerId,
  className = '',
}) => {
  // Calculate total amount
  const largeTotal = largeIceCubeAmount * pricingData.largeIceCubePriceTHB
  const smallTotal = smallIceCubeAmount * pricingData.smallIceCubePriceTHB
  const crushedTotal = crushedIceAmount * pricingData.crushedIcePriceTHB
  const coarselyCrushedTotal = coarselyCrushedIceAmount * pricingData.crushedIcePriceTHB

  const totalAmount = largeTotal + smallTotal + crushedTotal + coarselyCrushedTotal

  if (totalAmount <= 0) {
    return null
  }

  return (
    <div className={`bg-gray-50 rounded p-2 mt-2 ${className}`}>
      <div className='flex justify-between items-center'>
        <Text className='text-sm font-medium text-gray-700'>
          Total Amount
        </Text>
        <div className='text-right'>
          <div className='text-base font-bold text-green-600'>
            {formatCurrency(totalAmount)}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderTotalDisplay